var map = {
	"./female/body/0.png": 132,
	"./male/body/0.png": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;


//////////////////
// WEBPACK FOOTER
// ./src/layers ^\.\/.*\/body\/0\.png$
// module id = 371
// module chunks = 0